import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import {ScreenTransitionController} from "../base/ScreenTransitionController";
import $ from "jquery";

export class AIControlMainAppScreenTransition extends ScreenTransitionController {

  // Constructor
  constructor() {
    super();
    this.codingAnimationLoop = null;
    this.$currentScreen = null;
  }

  screen1InAnimation() {
    // Clear existing loop before starting a new one
    this.codingAnimationLoop?.kill();
    this.codingAnimationLoop = null;

    const TYPING_SPEED = 0.05;
    const PUNCTUATION_DELAY = 0.0;
    const LINE_DELAY = 0.22;
    const MAX_CHARS = 600;

    const activeCalls = [];

    const tick = (el, $el, $wrapper, rawText, state) => {
      if (!document.body.contains(el)) return;

      if (state.index >= rawText.length) {
        state.displayedText += "\n";
        $el.text(state.displayedText);
        activeCalls.push(gsap.delayedCall(LINE_DELAY, () => {
          state.index = 0;
          tick(el, $el, $wrapper, rawText, state);
        }));
        return;
      }

      const char = rawText[state.index++];
      state.displayedText += char;

      if (state.displayedText.length > MAX_CHARS) {
        const nl = state.displayedText.indexOf("\n");
        state.displayedText = nl !== -1
          ? state.displayedText.slice(nl + 1)
          : state.displayedText.slice(-MAX_CHARS);
      }

      $el.text(state.displayedText);

      // CRITICAL: Scroll the WRAPPER, not the container
      if ($el[0].scrollHeight > $wrapper[0].clientHeight) {
        $wrapper[0].scrollTop = $el[0].scrollHeight;
      }

      let delay = TYPING_SPEED;
      if (char === "\n") delay = LINE_DELAY;
      else if (/[.,();{}]/.test(char)) delay = PUNCTUATION_DELAY;

      activeCalls.push(gsap.delayedCall(delay, () => tick(el, $el, $wrapper, rawText, state)));
    };

    $("#screen-1").find(".code-output").each((i, el) => {
      const $el = $(el);
      // Find the wrapper that is inside the container
      const $wrapper = $el.closest('.code-container').find('.code-wrapper');
      const rawText = el.dataset.text || "";

      $el.text("");
      const state = {index: 0, displayedText: ""};
      activeCalls.push(gsap.delayedCall(0, () => tick(el, $el, $wrapper, rawText, state)));
    });

    this.codingAnimationLoop = {
      kill: () => {
        activeCalls.forEach(c => c.kill());
        activeCalls.length = 0;
      }
    };
  }

  screen1InLeftAnimation() {
    // When going from screen 2 to 1
    gsap.set(this.$currentScreen.find(".title, button.start-button"), {clearProps: "all"});
    gsap.set($(".header, #status-bar"), {autoAlpha: 0.0});
    gsap.set($(".header"), {width: "100%"});

    this.screenTransitionTimeline.add(() => {
      this.screen1InAnimation();
    });
    this.screenTransitionTimeline.fromTo(this.$currentScreen.find(".title, button.start-button"),
      {opacity: 0},
      {opacity: 1.0, duration: 1.0, ease: "power2.out"}, '<'
    );
    this.screenTransitionTimeline.to(this.$currentScreen.find(".code-output"), {
      opacity: 1.0, duration: 1.0, ease: "power2.out"
    }, '<');
  }

  screen1OutAnimation() {
    // When going from screen 1 to 2

    // Overlay expand
    this.screenTransitionTimeline.fromTo($(".screen-transition-overlay"),
      {width: '0%', height: '0%', autoAlpha: 1.0},
      {width: '102%', height: '102%', duration: 2, ease: 'power2.inOut'}
    );

    // Background fade in
    this.screenTransitionTimeline.fromTo($(".screen-transition-overlay .screen-transition-background"),
      {opacity: 0},
      {opacity: 1, duration: 2.0, ease: 'power2.inOut'},
      '<'
    );

    // Corners fade in
    this.screenTransitionTimeline.fromTo($(".screen-transition-overlay .screen-transition-corner"),
      {opacity: 0},
      {opacity: 1, duration: 0.1, ease: 'power2.inOut'},
      '<'
    );

    // Title out
    this.screenTransitionTimeline.to(this.$currentScreen.find(".title"), {
      y: -160, opacity: 0, duration: 0.8, ease: 'power2.in'
    }, '<');

    // CTA out
    this.screenTransitionTimeline.to(this.$currentScreen.find("button.start-button"), {
      y: 160, opacity: 0, duration: 0.8, ease: 'power2.in'
    }, '<');

    // Code animation out
    this.screenTransitionTimeline.to(this.$currentScreen.find(".code-output"), {
      opacity: 0, duration: 0.8, ease: 'power2.in'
    }, '<');
  }

  screen2InLeftAnimation() {
    // When going from screen 3 to 2

    // Resize header to fit layout
    this.screenTransitionTimeline.to($(".header"), {
        autoAlpha: 1.0, width: '100%',
        duration: 1.0, ease: "power2.out"
      }, '<'
    );

    // Algorithm container, IN
    this.$currentScreen.find(".algorithms-selectors-container .algorithm.view-mode-teaser").removeClass("selected");
    gsap.set(this.$currentScreen.find(".algorithms-selectors-container"), {scale: 1.0});
    gsap.set(this.$currentScreen.find(".algorithms-selectors-container .filter-button"), {autoAlpha: 1.0, y: "0%"});
    gsap.set(this.$currentScreen.find(".algorithms-selectors-container .algorithm .inner"), {autoAlpha: 1.0, y: "0%"});
    gsap.set(this.$currentScreen.find(".step-2 .blurring-text.explore-algorithm-text span:visible span"), {filter: "blur(0px)", y: 0});

    this.$currentScreen.find(".step-2 .blurring-text.explore-algorithm-text").removeClass("is-animated");

    this.screenTransitionTimeline.to(this.$currentScreen.find(".step-2 .blurring-text.explore-algorithm-text, .step-2 .blurring-text span:visible span"), {
      autoAlpha: 1.0, duration: 0.5, ease: "power2.out"
    });

    this.screenTransitionTimeline.to(this.$currentScreen.find(".algorithms-selectors-container"), {
      autoAlpha: 1.0, duration: 0.5,
      scale: 1.0, ease: "power2.out"
    }, '<');
  }

  screen2InRightAnimation() {
    // When going from screen 1 to 2

    // Destroy coding animation loop
    this.codingAnimationLoop?.kill();
    this.codingAnimationLoop = null;

    // Reset elements
    this.$currentScreen.find(".step-2 .blurring-text.explore-algorithm-text").removeClass("is-animated");
    gsap.set(this.$currentScreen.find(".step-2 .blurring-text.explore-algorithm-text"), {autoAlpha: 1});
    gsap.set(this.$currentScreen.find(".step-2 .drop-algorithm-text"), {autoAlpha: 0});
    gsap.set(this.$currentScreen.find(".step-2 .blurring-text.explore-algorithm-text span:visible span"), {autoAlpha: 1, filter: "blur(0px)", y: 0});
    gsap.set(this.$currentScreen.find(".step-2 .drop-algorithm-text span:visible span"), {autoAlpha: 0, filter: "blur(5px)", y: 15});
    gsap.set(this.$currentScreen.find(".step-1 .blurring-text"), {autoAlpha: 1.0});

    // Always hide the overlay that is used between screen 1 and 2
    this.screenTransitionTimeline.to($(".screen-transition-overlay"), {
      autoAlpha: 0.0, duration: 0.8, ease: 'power2.out'
    }, '<');

    // Resize header to fit layout
    this.screenTransitionTimeline.to($(".header"), {
      autoAlpha: 1.0, width: '100%',
      duration: 1.0, ease: "power2.out"
    }, '<');

    // Show status bar
    this.screenTransitionTimeline.to($("#status-bar"), {
      autoAlpha: 1.0, y: '0%',
      bottom: "14px", duration: 1.0, ease: "power2.out"
    }, '<');

    // Apply will-change just before animation
    this.screenTransitionTimeline.add(() => {
      gsap.set(this.$currentScreen.find(".blurring-text span span, .algorithms-selectors-container, .filter-button, .algorithm .inner"), {willChange: "transform, opacity, filter"});
    }, '<');

    // Step 1, words IN
    this.screenTransitionTimeline.fromTo(this.$currentScreen.find(".step-1 .blurring-text span:visible span"), {
      autoAlpha: 0, filter: "blur(5px)", y: 15
    }, {
      autoAlpha: 1, filter: "blur(0px)",
      y: 0, stagger: 0.18,
      duration: 1.20, ease: "power2.out"
    }, '<');

    // Step 1, words OUT
    this.screenTransitionTimeline.to(this.$currentScreen.find(".step-1 .blurring-text span:visible span"), {
      autoAlpha: 0, filter: "blur(5px)",
      y: -15, transformOrigin: "right center",
      stagger: {each: 0.15, from: "end"},
      duration: 0.50, ease: "power2.in",
      onComplete: () => gsap.set(this.$currentScreen.find(".step-1 .blurring-text"), {autoAlpha: 0.0})
    }, '>');

    // Step 2, words IN (Explore text)
    this.screenTransitionTimeline.fromTo(this.$currentScreen.find(".step-2 .blurring-text.explore-algorithm-text span:visible span"),
      {autoAlpha: 0, filter: "blur(5px)", y: 15},
      {autoAlpha: 1, filter: "blur(0px)", y: 0, stagger: 0.18, duration: 1.20, ease: "power2.out"},
      '>25%'
    );

    // Algorithm container, IN
    this.screenTransitionTimeline.fromTo(this.$currentScreen.find(".algorithms-selectors-container"),
      {autoAlpha: 0, scale: 0.75, borderColor: "transparent"},
      {autoAlpha: 1, scale: 1.0, borderColor: "#BFBFBF", duration: 0.60, ease: "power4.out"},
      '>'
    );

    // Algorithm filters, IN
    this.screenTransitionTimeline.fromTo(this.$currentScreen.find(".algorithms-selectors-container .filter-button"),
      {autoAlpha: 0, y: "102%"},
      {autoAlpha: 1, y: "0%", stagger: 0.09, duration: 0.90, ease: "power2.out"},
      "<"
    );

    // Algorithm items, IN
    this.screenTransitionTimeline.fromTo(this.$currentScreen.find(".algorithms-selectors-container .algorithm .inner"),
      {y: "-102%"},
      {y: "0%", stagger: 0.08, duration: 0.50, ease: "power2.out"},
      "<10%"
    );

    // Remove will-change after animation
    this.screenTransitionTimeline.add(() => {
      gsap.set(this.$currentScreen.find(".blurring-text span span, .algorithms-selectors-container, .filter-button, .algorithm .inner"), {clearProps: "willChange"});
    });
  }

  screen2OutLeftAnimation() {
    // When going from screen 2 to 1

    // Algorithm container, OUT
    this.screenTransitionTimeline.to(this.$currentScreen.find(".algorithms-selectors-container"), {
      scale: 0.90, duration: 1.0, ease: "power2.inOut",
    }, 0.25);

    // Algorithm filters, OUT
    this.screenTransitionTimeline.to(this.$currentScreen.find(".algorithms-selectors-container .filter-button"), {
      y: "100%", stagger: {each: 0.06, from: "start"},
      duration: 0.60, ease: "power2.in",
    }, 0.30);

    // Algorithm item, OUT
    this.screenTransitionTimeline.to(this.$currentScreen.find(".algorithms-selectors-container .algorithm .inner"), {
      y: "205px", stagger: {each: 0.05, from: "start"},
      duration: 0.35, ease: "power2.in",
    }, 0.40);

    // Step 2, words OUT
    this.screenTransitionTimeline.to(this.$currentScreen.find(".step-2 .blurring-text span:visible span"), {
      autoAlpha: 0, filter: "blur(5px)",
      y: -12, stagger: {each: 0.08, from: "end"},
      duration: 0.45, ease: "power2.in",
      onComplete: () => gsap.set(this.$currentScreen.find(".step-2 .blurring-text"), {autoAlpha: 0.0})
    }, 0.40);

    // Algorithm container, OUT
    this.screenTransitionTimeline.to(this.$currentScreen.find(".algorithms-selectors-container"), {
      autoAlpha: 0, duration: 0.45, ease: "power2.in"
    }, 0.75);
  }

  screen2OutRightAnimation() {
    // When going from screen 2 to 3

    // Algorithm container, OUT
    this.screenTransitionTimeline.to(this.$currentScreen.find(".algorithms-selectors-container"), {
      scale: 0.375, duration: 1.75, ease: "power4.inOut",
    }, 0.25);

    // Algorithm filters, OUT
    this.screenTransitionTimeline.to(this.$currentScreen.find(".algorithms-selectors-container .filter-button"), {
      y: "100%", stagger: {each: 0.09, from: "start"},
      duration: 0.80, ease: "power4.in",
    }, 0.30);

    // Algorithm item, OUT
    this.screenTransitionTimeline.to(this.$currentScreen.find(".algorithms-selectors-container .algorithm .inner"), {
      y: "205px", stagger: {each: 0.07, from: "start"},
      duration: 0.40, ease: "power4.in",
    }, 0.40);

    // Step 2, words OUT
    gsap.killTweensOf(this.$currentScreen.find(".step-2 .blurring-text span span"));
    this.screenTransitionTimeline.to(this.$currentScreen.find(".step-2 .blurring-text span span").filter(":visible"), {
      autoAlpha: 0, filter: "blur(5px)", y: -20,
      stagger: {each: 0.10, from: "end"}, duration: 0.60, ease: "power4.in", overwrite: true,
      onComplete: () => gsap.set(this.$currentScreen.find(".step-2 .blurring-text"), {autoAlpha: 0.0})
    }, 0.40);

    // Algorithm container, OUT
    this.screenTransitionTimeline.to(this.$currentScreen.find(".algorithms-selectors-container"), {
      autoAlpha: 0, duration: 0.65, ease: "power4.in"
    }, 0.90);

    // Resize header to fit new layout
    this.screenTransitionTimeline.to($(".header"), {
      width: '1480px', duration: 1.0, ease: "power2.inOut"
    }, 0.80);
  }

  screen3InAnimation() {
    // Reset elements
    gsap.set(this.$currentScreen.find(".idle-container"), {autoAlpha: 1, y: 0});
    gsap.set(this.$currentScreen.find(".idle-overlay, .idle-element"), {autoAlpha: 0, y: 0});
    gsap.set([
      this.$currentScreen.find(".main-info .algorithm-title"),
      this.$currentScreen.find(".main-info .algorithm-description"),
      ...this.$currentScreen.find(".kpis-container .kpi").toArray().map(el => $(el)),
      ...this.$currentScreen.find(".widgets-container .widget").toArray().map(el => $(el)),
      this.$currentScreen.find(".options-container .algorithm-selector-container"),
      this.$currentScreen.find(".options-container .building-selector-container"),
      ...this.$currentScreen.find(".options-container .user-input-selector-container").toArray().map(el => $(el)),
    ].map(el => el[0] ?? el), {opacity: 0.0, y: 24});

    // ONLY fade in the main containers if coming from screen 1 or 2
    if (this.fromId <= 2) {
      this.screenTransitionTimeline.fromTo(
        [this.$currentScreen.find(".algorithm-details-container"), this.$currentScreen.find(".options-container")],
        {opacity: 0},
        {opacity: 1, duration: 0.50, ease: "power2.out"}
      );
    }

    app.audio.play("audio/RevealElements_1.wav", 1, true)

    // Stagger elements after containers
    this.screenTransitionTimeline.fromTo([
        this.$currentScreen.find(".main-info .algorithm-title"),
        this.$currentScreen.find(".main-info .algorithm-description"),
        ...this.$currentScreen.find(".kpis-container .kpi").toArray().map(el => $(el)),
        ...this.$currentScreen.find(".widgets-container .widget").toArray().map(el => $(el)),
        this.$currentScreen.find(".options-container .algorithm-selector-container"),
        this.$currentScreen.find(".options-container .building-selector-container"),
        ...this.$currentScreen.find(".options-container .user-input-selector-container").toArray().map(el => $(el)),
      ],
      {opacity: 0, y: 24},
      {opacity: 1, y: 0, duration: 0.6, ease: "power2.out", stagger: 0.04},
      "<"
    );
  }

  screen3OutAnimation() {
    // Stagger elements out from end to start
    this.screenTransitionTimeline.fromTo([
        this.$currentScreen.find(".main-info .algorithm-title"),
        this.$currentScreen.find(".main-info .algorithm-description"),
        ...this.$currentScreen.find(".kpis-container .kpi").toArray().map(el => $(el)),
        ...this.$currentScreen.find(".widgets-container .widget").toArray().map(el => $(el)),
        this.$currentScreen.find(".options-container .algorithm-selector-container"),
        this.$currentScreen.find(".options-container .building-selector-container"),
        ...this.$currentScreen.find(".options-container .user-input-selector-container").toArray().map(el => $(el)),
      ],
      {opacity: 1, y: 0},
      {opacity: 0, y: -24, duration: 0.30, ease: "power2.in", stagger: {each: 0.03, from: "end"}},
      "<"
    );
  }

  reset() {
  }
}
